export default class NoticiaCreateNoticiaController {
  constructor($q, $state, $scope, AuthenticationService, UIService, NoticiaService, Noticia) {
    this.$q = $q;
    this.state = $state;
    this.$scope = $scope;
    this.UI = UIService;
    this.user = AuthenticationService.getUser();
    this.NoticiaService = NoticiaService;
    this.loaded = false;

    this.Noticia = Noticia;
    this.simnao = [{ name: "Sim", value: 1 }, { name: "Não", value: 0 }];

    this.emptyData = {
      form: 1,
      details: {},
    };

    // Configuration for date picker data
    this.dateOptions = {
      dataInicio: {format: 'DD/MM/YYYY'},
      dataFim: {format: 'DD/MM/YYYY'}
    };

    // Load data to fill ui-selects
    this.loadAuxData();

    $scope.$watch(() => {
      return this.data;
    }, (val) => {
      if (angular.isDefined(val)) {
        localStorage.setItem('ISR_SGI_NoticiaNewForm', JSON.stringify(val));
      }
    }, true);
  }

  loadAuxData = () => {
    this.loadDataFromStorage();
    this.loaded = true;
  };

  // Infinite Scroll magic
  addMoreItems = (infiniteScroll) => {
    infiniteScroll.currentItems += infiniteScroll.numToAdd;
  };

  loadDataFromStorage = () => {
    if (localStorage.getItem('ISR_SGI_NoticiaNewForm')) {
      let storageData = JSON.parse(localStorage.getItem('ISR_SGI_NoticiaNewForm'));
      // Only use what is required
      this.data = {};
      if (storageData.form) this.data.form = storageData.form; else this.data.form = angular.copy(this.emptyData.form);
      if (storageData.details) this.data.details = storageData.details; else this.data.details = angular.copy(this.emptyData.details);
    } else {
      this.data = angular.copy(this.emptyData);
    }
    this.state.transitionTo('app.noticia.new.' + this.data.form);
  };

  setForm = num => {
    this.data.form = num;
    this.state.transitionTo('app.noticia.new.' + this.data.form);
  };

  cleanForm = () => {
    // Clean filled data
    this.data = angular.copy(this.emptyData);
    this.state.transitionTo('app.noticia.new.' + this.data.form);
  };

  submit = () => {
    this.isValid().then(() => {
      this.loaded = false;
      // Create Noticia and related data
      this.data.details.id = 0;

      // If urlText is empty with a URL, make it be the same
      this.data.details.urlText = this.data.details.urlText || this.data.details.url;

      this.data.details.criadoPorId = this.user.id;
      this.data.details.dataCriacao = moment().format();
      this.data.details.atualizadoPorId = this.user.id;
      this.data.details.atualizadoa = moment().format();

      this.Noticia.create(this.data.details).$promise.then((noticia) => {
        this.UI.addToast("Draft de notícia criado com sucesso");

        localStorage.removeItem('ISR_SGI_NoticiaNewForm');
        this.state.go('app.noticia.details', {id: noticia.id});
      }).catch((error) => {
        console.log(error);
        this.UI.showAlert("Erro ao criar notícia. Verifique a ligação");
        this.loaded = true;
      });
    }).catch((x) => {
      // Nothing to do. Just fix values and resubmit...
    });
  };

  isValid = () => {
    let validDefer = this.$q.defer();
    let v = true;

    // Check if noticia data is well defined
    // Título
    if (v && (!this.data.details.titulo || this.data.details.titulo.length === 0 || this.data.details.titulo.length > 255)) {
      this.UI.addToast("Título da notícia não preenchida");
      v = false;
      validDefer.reject();
    }
    if (v && (this.data.details.titulo.length > 255)) {
      this.UI.addToast("Título demasiado longo");
      v = false;
      validDefer.reject();
    }

    // Slug
    if (v && (!this.NoticiaService.isValidSlug(this.data.details.slug))) {
      this.UI.addToast("Slug inválido, use apenas letras minúsculas, números e hífenes, sem espaços nem acentos.");
      v = false;
      validDefer.reject();
    }

    // Descrição
    if (v && (!this.data.details.descricao || this.data.details.descricao.length === 0)) {
      this.UI.addToast("Corpo da Notícia não preenchido");
      v = false;
      validDefer.reject();
    }

    // URL
    if (v && (!this.NoticiaService.isValidURL(this.data.details.url))) {
      this.UI.addToast("URL inválido");
      v = false;
      validDefer.reject();
    }

    // Data de Início
    if (v && (this.data.details.dataInicio && !moment(this.data.details.dataInicio).isValid())) {
      this.UI.addToast("Data de Início inválida");
      v = false;
      validDefer.reject();
    }
    // Data de Fim
    if (v && (this.data.details.dataFim && !moment(this.data.details.dataFim).isValid())) {
      this.UI.addToast("Data de Fim inválida");
      v = false;
      validDefer.reject();
    }

    // Only validate multidata if all static data is valid, otherwise no point first
    if (v) {
      // VALIDATE ASYNC DATA
      let idData = [];

      // If value is filled, we need to check if it exists already too
      idData.push({
        field: 'slug',
        value: this.data.details.slug,
        model: this.Noticia,
        resolveOnExist: false,
        error: "Já existe este slug associado a outra notícia"
      });

      let wait = this.UI.showWaiting();
      // Verify all the async data
      this.NoticiaService.validateMultiData(idData).then(x => {
        wait.close();
        validDefer.resolve();
      }).catch(() => {
        wait.close();
        validDefer.reject();
      });
    }
    return validDefer.promise;
  };

  updateSlug = () => {
    this.data.details.slug = this.NoticiaService.stringToSlug(this.data.details.titulo);
  };

}

NoticiaCreateNoticiaController.$inject = ['$q', '$state', '$scope', 'AuthenticationService', 'UIService', 'NoticiaService', 'Noticia'];
